export { default } from './product-core-deposit';
